import React from 'react';
import { PaymentDetailsBillingAddressForm } from '../payment-details-billing-address-form';
import { PaymentDetailsTitleLine } from '../payment-details-title-line';
import FormCheckbox from '../form-checkbox';
export class PaymentDetailsBillingAddress extends React.PureComponent {
  render() {
    const {
      isDeliveryToCustomer,
      disableWholeForm = false,
      isFixedStyles = false
    } = this.props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentDetailsTitleLine, {
      isFixedStyles: isFixedStyles,
      title: "Billing Address"
    }, isDeliveryToCustomer && /*#__PURE__*/React.createElement(FormCheckbox, {
      label: "Same as shipping",
      name: "sameAsShipping",
      dataInput: "SameAsShipping"
    })), /*#__PURE__*/React.createElement(PaymentDetailsBillingAddressForm, {
      isFixedStyles: isFixedStyles,
      disableWholeForm: disableWholeForm
    }));
  }
}